<template>
  <div class="container in-app">
    <AppMask class="flex-wrap flex-center" style="background:var(--bg2);border-left:1px solid var(--border);overflow:hidden;z-index:1000;color:var(--subtext2);transition:all 0.3s ease-out" v-if="loading" :style="ready?'':'top:120%;'">
      <div class="flex-col">
      <h2 style="font-size:40px">{{ name }}</h2>
      <div class="flex-wrap" style="margin-top:10px">
      <BaseIcon :icon="icon" color="var(--subtext2)" size="40" />
      <BaseLoading style="margin:0" />
      <BaseIcon :icon="icon2" color="var(--subtext2)" size="40" />
      </div>

      </div>
    </AppMask>
    <AppMask class="flex-wrap flex-center" style="background:var(--bg1);border-left:1px solid var(--border);color:#fff;transition:all 0.3s ease-out;bottom:50%;" v-if="loading" :style="ready?'':'bottom:120%'">
      <div>
      </div>
    </AppMask>
    <slot></slot>
  </div>
</template>

<script>
import AppMask from '@/components/app/mask';
export default {
  components: {
    AppMask,
  },
  props: {
    name: {
      type: String,
      default: '应用加载中',
    },
    icon: {
      type: String,
      default: 'nbgz',
    },
    icon2: {
      type: String,
      default: 'md-apps',
    },
    ready: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="less" scoped>
.in-app{
  background:none;
}
</style>
